/* DIE BUEHNE IN DER ZEITLEISTE - die sechs Unterschritte von Station 05.

   SIE WIRD MIT ZWEI PFEILEN DURCHGEBLAETTERT (02.10.2026, Vorgabe Claras: erst "bei Mobile bei
   Ablauf, Phase 5, die Unterschritte - das mit dem Scrollen entfernen und dafuer Pfeile
   einsetzen, um von rechts nach links zu swipen", dann "mach das mit den Pfeilen auch bei der
   Desktop-Version").

   HIER STAND BIS DAHIN EIN SCROLL-EINGRIFF, und es lohnt zu wissen, warum es ihn gab und warum
   er weg ist. Claras Vorgabe vom 28.09.2026 lautete: "wenn das Scrollen bei dem Feld mit der
   Zahl 05 ankommt, soll das Scrollen der kompletten Seite sofort aufhoeren und wenn man
   weiterhin scrollt, direkt die Unterschritte von rechts nach links anfangen zu scrollen."
   Fuenf Fassungen hat das gebraucht - vier davon mit position:sticky, die alle daran
   scheiterten, dass sticky die Seite ja gerade laufen laesst. Die fuenfte fing Rad und Wisch ab
   (preventDefault) und schob stattdessen die Spur weiter; die Seite stand dabei still.

   DAS FUNKTIONIERTE, erklaerte sich aber niemandem von selbst: Eine Seite, die auf Scrollen
   nicht reagiert, wirkt kaputt, bevor sie als Absicht erkannt wird - auf dem Telefon noch mehr
   als am Schreibtisch. Zwei Knoepfe sagen dagegen, was zu tun ist. Was dabei verlorengeht, ist
   die Automatik; was gewonnen wird, ist, dass die Seite immer scrollt, wenn man scrollt.

   WAS DIESE DATEI JETZT NOCH TUT: Sie schiebt die Spur, zaehlt mit und markiert den aktiven
   Schritt. Mehr nicht.

   OHNE SKRIPT bleibt die Spur seitlich wischbar (overflow-x im Stylesheet). Wer keine Bewegung
   will (prefers-reduced-motion), bekommt die Schritte untereinander. */
(function(){
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var buehnen=[].slice.call(document.querySelectorAll('[data-rm-buehne]'));
  if(!buehnen.length) return;

  buehnen.forEach(function(b){
    var spur=b.querySelector('[data-rm-spur]');
    var liste=spur && spur.querySelector('.rm-sub');
    if(!spur || !liste) return;
    var schritte=[].slice.call(liste.children);
    if(schritte.length < 2) return;
    b.classList.add('laeuft');
    b.style.setProperty('--rmb-n', schritte.length);
    var zahl=b.querySelector('[data-rm-zahl]');
    var idx=0;
    zeichne();

    function zeichne(){
      liste.style.transform='translate3d(' + (-idx*100/schritte.length) + '%,0,0)';
      if(zahl) zahl.textContent=idx+1;
      schritte.forEach(function(s,k){ s.classList.toggle('an', k===idx); });
    }

    function weiter(runter){
      if(runter){ if(idx < schritte.length-1){ idx++; zeichne(); } }
      else       { if(idx > 0){ idx--; zeichne(); } }
    }

    /* ---- DIE PFEILE SIND DER EINZIGE WEG (02.10.2026) --------------------------------------
       Vorgabe Claras, in zwei Schritten: erst "bei Mobile bei Ablauf, Phase 5, die Unterschritte
       - das mit dem Scrollen entfernen und dafuer Pfeile einsetzen", dann "mach das mit den
       Pfeilen auch bei der Desktop-Version".

       DAMIT IST DIE SCROLL-UEBERNAHME GANZ ENTFALLEN - und mit ihr der groesste Eingriff, den
       dieses Theme je in das Verhalten der Seite gemacht hat. Sie fing Rad und Wisch ab, solange
       die Station an ihrem Platz stand, und schob stattdessen die Spur weiter; die Seite stand
       dabei still. Das war Claras Vorgabe vom 28.09.2026 und hat vier Fassungen gebraucht.

       WARUM SIE JETZT WEG IST: Eine Seite, die auf das Scrollen nicht reagiert, erklaert sich
       niemandem von selbst. Zwei Knoepfe tun es. Was dabei verlorengeht, ist die Automatik -
       was gewonnen wird, ist, dass man sieht, was zu tun ist, und dass die Seite immer scrollt,
       wenn man scrollt.

       WAS GEBLIEBEN IST: zeichne() und weiter() - die Spur selbst, der Zaehler und die
       Markierung des aktiven Schritts. Entfallen sind die Horcher auf wheel und touchmove und
       alles, was nur ihnen diente: die Halteposition (ZIEL_ANTEIL, abstand, sichtbar,
       anPosition), die Annahme-Logik (nimmt, freiUnten, freiOben, aktiv) und die Zaehlwerte fuer
       Trackpad und Finger (SCHWELLE, SPERRE, summe, letzterY, sperreBis). Stehen zu lassen, was
       nichts mehr tut, waere die sichere Art, beim naechsten Mal falsch zu suchen.

       OHNE SKRIPT bleibt die Spur seitlich wischbar (overflow-x im Stylesheet) - daran aendert
       sich nichts. */
    b.querySelectorAll('[data-rm-pfeil]').forEach(function(p){
      p.addEventListener('click', function(){
        weiter(p.getAttribute('data-rm-pfeil') === '1');
      });
    });
  });
})();
